import control from './control'
import nodify from './nodify'


export default (measurements, config) => {
  control(config)
  nodify(measurements, config)
}
